import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CenterService {
  private readonly SELECTED_KEY = 'bb_selected_center';
  private readonly LIST_KEY     = 'bb_manager_centers';

  private selectedSubject = new BehaviorSubject<any>(this._loadSelected());
  selectedCenter$: Observable<any> = this.selectedSubject.asObservable();

  constructor(private api: ApiService) {}

  get selectedCenter(): any { return this.selectedSubject.value; }

  setSelectedCenter(center: any): void {
    localStorage.setItem(this.SELECTED_KEY, JSON.stringify(center));
    this.selectedSubject.next(center);
  }

  getCachedCenters(): any[] {
    const raw = localStorage.getItem(this.LIST_KEY);
    return raw ? JSON.parse(raw) : [];
  }

  setCachedCenters(centers: any[]): void {
    localStorage.setItem(this.LIST_KEY, JSON.stringify(centers));
  }

  loadCentersForManager(managerId: string): Observable<any[]> {
    return this.api.getCentersByManager(managerId);
  }

  clear(): void {
    localStorage.removeItem(this.SELECTED_KEY);
    localStorage.removeItem(this.LIST_KEY);
    this.selectedSubject.next(null);
  }

  private _loadSelected(): any {
    const raw = localStorage.getItem(this.SELECTED_KEY);
    return raw ? JSON.parse(raw) : null;
  }
}
